import { render, staticRenderFns } from "./FieldIcon.vue?vue&type=template&id=1945c237&scoped=true"
import script from "./FieldIcon.vue?vue&type=script&lang=js"
export * from "./FieldIcon.vue?vue&type=script&lang=js"
import style0 from "./FieldIcon.vue?vue&type=style&index=0&id=1945c237&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1945c237",
  null
  
)

export default component.exports